import { Link } from "react-router-dom";
import PartnerGroupedListingCard from "./PartnerGroupedListingCard";

export default function PartnerInventoryUnclassifiedBucket({
  title = "Unclassified",
  count = 0,
  reason,
  listings = [],
  dealerId,
  path,
  reviewPath,
  prominent = false,
  warningLabel = "Needs review",
  showReviewLink = true,
  showBulkNormalizeHint = false,
}) {
  if (!count) return null;

  return (
    <section
      className={`partner-grouped-unclassified${prominent ? " partner-grouped-unclassified--prominent" : ""}`}
      aria-label={`${title} listings`}
    >
      <header className="partner-grouped-unclassified__header">
        <div>
          <h3>
            {title} ({count})
          </h3>
          {reason ? <p className="muted">{reason.replace(/_/g, " ")}</p> : null}
        </div>
        <span className="partner-grouped-review-badge" aria-label={warningLabel}>
          ⚠ {warningLabel}
        </span>
      </header>
      {showReviewLink ? (
        <div className="partner-grouped-unclassified__links">
          <Link className="cv-button-link" to={reviewPath}>
            Fix vehicle names
          </Link>
          {showBulkNormalizeHint ? (
            <Link className="cv-button-link" to={reviewPath.replace(/\?.*$/, "")}>
              Open review queue
            </Link>
          ) : null}
        </div>
      ) : null}
      {listings.length ? (
        <div className="partner-grouped-listings">
          {listings.map((listing) => (
            <PartnerGroupedListingCard
              key={listing.id}
              listing={listing}
              dealerId={dealerId}
              path={path}
              reviewPath={reviewPath}
            />
          ))}
        </div>
      ) : null}
    </section>
  );
}
